<template>
  <div class="ingredient_edit_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <form @submit.prevent="updateIngredient" style="padding:15px;">
            <div class="form-group">
              <label for="name">Name*</label>
              <input
                :class="{
                  'is-invalid': $v.form.name.$invalid && submit,
                  'is-valid': !$v.form.name.$invalid && submit
                }"
                type="text"
                v-model="form.name"
                class="form-control"
                id="name"
                name="name"
                aria-describedby="name_help"
                placeholder="i.e: abc123"
              />
              <div class="invalid-feedback">
                Please provide a Name
              </div>
            </div>
              <div class="form-group">
                  <label for="coa">COA</label>
                  <input
                      :class="{
                  'is-invalid': $v.form.coa.$invalid && submit,
                  'is-valid': !$v.form.coa.$invalid && submit
                }"
                      type="text"
                      v-model="form.coa"
                      class="form-control"
                      id="coa"
                      name="coa"
                      aria-describedby="coa_help"
                      placeholder="i.e: abc123"
                  />
                  <div class="invalid-feedback">
                      Please provide a COA
                  </div>
              </div>



            <div class="form-group">
              <label for="alternative_name">Alternative name</label>
              <input
                :class="{
                  'is-invalid': $v.form.alternativeName.$invalid && submit,
                  'is-valid': !$v.form.alternativeName.$invalid && submit
                }"
                type="text"
                v-model="form.alternativeName"
                class="form-control"
                id="alternative_name"
                name="alternative_name"
                aria-describedby="alternative_name_help"
                placeholder="i.e: a1"
              />
              <div class="invalid-feedback">
                Please provide a Alternative name
              </div>
            </div>

            <div class="form-group">
              <label for="cas_number">CAS Number</label>
              <input
                :class="{
                  'is-invalid': $v.form.casNumber.$invalid && submit,
                  'is-valid': !$v.form.casNumber.$invalid && submit
                }"
                type="text"
                v-model="form.casNumber"
                class="form-control"
                id="cas_number"
                name="cas_number"
                aria-describedby="cas_number_help"
                placeholder="i.e: a1"
              />
              <div class="invalid-feedback">
                Please provide a CAS number
              </div>
            </div>

            <b-btn variant="success" size="md" class="float-left" type="submit">Update Ingredient</b-btn>
            <b-btn
              variant="default"
              size="md"
              class="float-right"
              :to="'/ingredients/'"
            >Cancel</b-btn
            >
            <br />
            <br />
            <br />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";

export default {
  name: "ingredient-edit",
  components: {
    DatePicker
  },
  mounted() {
    this.getIngredient();
  },
  data() {
    return {
      form: {
          name: "",
          coa: "",
          alternativeName: "",
          casNumber: "",
      },
      submit: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Ingredients", to: { name: "ingredients" } },
        { text: "Edit Ingredient", active: true }
      ]
    };
  },
  validations() {
    return {
      form: {
        name: {
          required
        },
        coa: {},
        alternativeName: {},
        casNumber: {}
      }
    };
  },
  methods: {
    getIngredient() {
      let loader = this.$loading.show();
      this.$http
      .get(
        this.APIURL +
        this.BRAND +
        "/ingredients/" +
        this.$route.params.id +
        "/edit"
      )
      .then(
        response => {
          this.form.name = response.data.name;
          this.form.coa = response.data.coa;
          this.form.alternativeName = response.data.alternative_name;
          this.form.casNumber = response.data.cas_number;
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
    updateIngredient() {
      this.submit = true;

      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let ingredient = {
          name: this.form.name,
          coa:this.form.coa,
          alternative_name: this.form.alternativeName,
          cas_number: this.form.casNumber,
        };
        this.$http
        .put(
          this.APIURL + this.BRAND + "/ingredients/" + this.$route.params.id,
          ingredient
        )
        .then(
          () => {
            this.$swal({
              title: "Success!",
              showConfirmButton: false,
              timer: 1000,
              html:
                "Ingredient added successfully, taking you back to ingredients list.",
              type: "success",
              onClose: () => {
                loader.hide();
                this.$router.push({ name: "ingredients" });
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    }
  }
};
</script>
